import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=57f19418&scoped=true&"
import script from "./CreateNews.vue?vue&type=script&lang=js&"
export * from "./CreateNews.vue?vue&type=script&lang=js&"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=57f19418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f19418",
  null
  
)

export default component.exports